import { resetSchoolDataCacheSyncState } from './schoolDataCacheVersion';
import { clearProgramScopedScopeServerValidatedRegistry } from './programScopedRowsServerValidatedSession';
import { isSubscriptionPassStorageKey } from './subscriptionPassStorage';

/**
 * 현재 워크스페이스의 `cp.*` / `cp-*` 로컬 캐시만 제거한다.
 * 로그인(Supabase), 학교·학년 선택, 테마, 이메일 기억 등은 유지한다.
 */
export function clearWorkspaceCpLocalCaches(workspaceId: string): number {
  if (typeof window === 'undefined') return 0;
  const ws = workspaceId.trim();
  if (!ws) return 0;

  const keysToRemove: string[] = [];
  for (let index = 0; index < window.localStorage.length; index += 1) {
    const key = window.localStorage.key(index);
    if (!key) continue;
    const isCpKey = key.startsWith('cp.') || key.startsWith('cp-');
    if (!isCpKey) continue;
    if (isSubscriptionPassStorageKey(key)) continue;
    if (!key.includes(ws)) continue;
    /** 연간시간표 보기 토글은 캐시가 아니라 사용자 설정 — 캐시 정리로 초기화하지 않음 */
    if (
      key.startsWith('cp.annualSwapTermOrder.v1.') ||
      key.startsWith('cp.annualShowSaturday.v1.') ||
      key.startsWith('cp.annualShowAllClasses.v1.')
    ) {
      continue;
    }
    keysToRemove.push(key);
  }

  keysToRemove.forEach((key) => window.localStorage.removeItem(key));
  resetSchoolDataCacheSyncState(ws);

  try {
    window.sessionStorage.clear();
  } catch {
    // ignore
  }
  clearProgramScopedScopeServerValidatedRegistry();

  return keysToRemove.length;
}
